import { defineElement, html } from '@webtides/element-js';
import { ifDefined } from 'lit-html/directives/if-defined';
import { classMap } from 'lit-html/directives/class-map.js';

import BaseInputField from '../../../../legacy-library/webcomponents/_form/input-field/input-field.class';
import style from './input-field.css';

export default class InputField extends BaseInputField {
    constructor() {
        super({ styles: [style] });
    }

    fieldTemplate() {
        if (this.type === 'textarea') {
            const classes = { 'is-valid': !!this.valid, 'is-invalid': !this.valid };

            return html`
                <textarea
                    ref='input'
                    id='input-${this.name}'
                    name='${this.name}'
                    type='${this.type}'
                    placeholder='${this.placeholder}'
                    ?required='${this.required}'
                    ?disabled='${this.disabled}'
                    aria-describedby='${this.name}-help'
                    pattern=${ifDefined(this.pattern ? this.pattern : undefined)}
'                   minlength=${ifDefined(this.minlength ? this.minlength : undefined)}
                    maxlength=${ifDefined(this.maxlength ? this.maxlength : undefined)}
                >${this.value}</textarea>
                ${
                    this.touched
                        ? html`
                              <div class="validity ${classMap(classes)}">
                                  ${this.valid ? this.validIndicatorTemplate() : this.invalidIndicatorTemplate()}
                              </div>
                          `
                        : ''
                }
            `;
        }

        return super.fieldTemplate();
    }
}

defineElement('input-field', InputField);
